
/**
 * Determines if the input is an email or phone number
 * @param {string} input - The input to check
 * @returns {Object} Object containing type ('email', 'mobile', or 'invalid') and formatted value
 */
export const identifyInputType = (input) => {
  if (!input) return { type: 'invalid', value: input };
  
  // Remove all spaces and special characters for phone validation
  const cleanedInput = input.replace(/\s+/g, '');
  
  // Email regex pattern
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // Phone regex pattern (10 digits, may start with +91 or 91)
  const phoneRegex = /^(\+?91)?[6-9]\d{9}$/;
  
  if (emailRegex.test(input)) {
    return { type: 'email', value: input.trim() };
  } else if (phoneRegex.test(cleanedInput)) {
    // Format phone number to standard format (remove +91 or 91 prefix)
    let formattedPhone = cleanedInput;
    if (formattedPhone.startsWith('+91')) {
      formattedPhone = formattedPhone.substring(3);
    } else if (formattedPhone.startsWith('91') && formattedPhone.length > 10) {
      formattedPhone = formattedPhone.substring(2);
    }
    return { type: 'mobile', value: formattedPhone };
  }
  
  return { type: 'invalid', value: input };
};

/**
 * Validates password strength
 * @param {string} password - The password to validate
 * @returns {Object} Object containing isValid flag and message
 */
export const validatePassword = (password) => {
  if (!password) {
    return { isValid: false, message: 'Password is required' };
  }
  
  if (password.length < 8) {
    return { isValid: false, message: 'Password must be at least 8 characters long' };
  }
  
  // Check for at least one uppercase letter
  if (!/[A-Z]/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one uppercase letter' };
  }
  
  // Check for at least one lowercase letter
  if (!/[a-z]/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one lowercase letter' };
  }
  
  // Check for at least one number
  if (!/\d/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one number' };
  }
  
  // Check for at least one special character
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    return { isValid: false, message: 'Password must contain at least one special character' };
  }
  
  return { isValid: true, message: 'Password is strong' };
}; 